import React, { useEffect, useState, useRef } from "react";
import clsx from "clsx";
import useStyles from "./styles";

export default function MobileAboutKm() {
  const classes = useStyles();
  const [showAllFaqs, setShowAllFaqs] = useState(false);

  const faqSectionRef = useRef(null);

  const handleFaqToggle = () => {
    if (showAllFaqs) {
      setShowAllFaqs(false);

      setTimeout(() => {
        faqSectionRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 0);
    } else {
      setShowAllFaqs(true);
    }
  };

  const faqData = [
    {
      question: "What is KheloMore?",
      answer:
        "KheloMore is a sports community platform that helps users discover and book sports venues for their favourite activities. Users can also host games and join games near them, making it easier to find places and opportunities to play.",
    },

    {
      question: "What sports venues can I book on KheloMore?",
      answer:
        "KheloMore allows users to discover and book a wide range of sports venues, including cricket grounds, football turfs, badminton courts, pickleball courts, and other sports facilities across locations.",
    },

    {
      question: "How can I book a sports venue on KheloMore?",
      answer:
        "You can search for a venue based on your preferred sport, location, and availability, choose your preferred time slot, and complete your booking through KheloMore.",
    },

    {
      question: "Can I host games on KheloMore?",
      answer:
        "Yes, KheloMore allows users to host games by creating sports activities and inviting participants to join, making it easier to organize and play sports.",
    },

    {
      question: "Can I join games near me on KheloMore?",
      answer:
        "Yes, users can discover and join games happening near them, helping them participate in more sports activities and enjoy playing with others.",
    },

    {
      question: "Why should I choose KheloMore for sports bookings?",
      answer:
        "KheloMore helps you find trusted sports venues, book your preferred playing space, and enjoy a simpler way to plan and participate in sports activities.",
    },
  ];

  return (
    <>
      <main>
        <div>
          <img
            className={clsx(classes.heroImg, classes.w100)}
            src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-home-page-2025/km-summary.png"
            alt="km-summary"
          />
        </div>
        <div
          className={clsx(
            classes.flex,
            classes.spaceBw,
            classes.alignStart,
            classes.mlr60,
          )}
        >
          <h1 className={classes.w40}>
            <span className={classes.playText}>KheloMore’s Vision</span>
            <p className={classes.tapPara}>Beyond booking a place to play</p>
          </h1>
          <div className={clsx(classes.w15, classes.mt140)}>
            <img
              className={classes.mArrow}
              src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-home-page-2025/movement-arrow.png"
              alt="arrow"
            />
          </div>
          <div className={clsx(classes.w40, classes.mt100)}>
            <h2 className={classes.tapPara}>
              KheloMore helps you find games, find people, and play more.
            </h2>
          </div>
        </div>
        <div>
          <img
            className={clsx(classes.heroImg, classes.w100)}
            src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-home-page-2025/mob-km-community.png"
            alt="km-summary"
          />
        </div>
        {/* next game meetup */}
        <div
          className={clsx(
            classes.flex,
            classes.spaceBw,
            classes.alignStart,
            classes.flexCol,
            classes.mlr60,
          )}
        >
          <div className={classes.w100}>
            <span className={classes.playText}>Tap and Play</span>
            <h2 className={classes.tapHead}>YOUR NEXT GAME STARTS HERE</h2>
            <p className={classes.tapPara}>
              Whatever gets you playing, you’ll find it on KheloMore. Find a
              game, host one, find people to play with, or book a place to play.
              From your first game to your regular crew, KheloMore helps you
              make sport happen.
            </p>
            <p className={clsx(classes.tapPara, classes.mt16)}>
              Discover a wide range of courts and turfs for 30+ variety of
              sports.
            </p>
            <div className={classes.inlineBlock}>
              <a
                className={classes.cta}
                href="https://www.khelomore.com/sports-venues"
                target="_blank"
              >
                Book a Court Now
                <img
                  className={clsx(classes.flex, classes.arrow)}
                  src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-home-page-2025/right-arrow.png"
                  alt="right-arrow"
                />
              </a>
            </div>
          </div>
          <div className={classes.w100}>
            <img
              className={clsx(classes.meetupImg, classes.w100, classes.mt24)}
              src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-home-page-2025/user-meet.png"
              alt="user meet"
            />
          </div>
        </div>
        {/* user meet */}
        <div
          className={clsx(
            classes.flex,
            classes.spaceBw,
            classes.alignStart,
            classes.flexCol,
            classes.mlr60,
          )}
        >
          <div className={classes.w100}>
            <span className={classes.playText}>Bring Your A-Game</span>
            <h2 className={classes.tapHead}>Play It. Own It. Win It.</h2>
            <p className={classes.tapPara}>
              From beginner leagues to full-blown tournaments, bring your
              community together through sports. Search for your favourite
              games, invite players, and make it a match to remember - all
              through KheloMore.
            </p>
            <div className={classes.inlineBlock}>
              <a
                className={classes.cta}
                href="https://www.khelomore.com/events/explore-events"
                target="_blank"
              >
                Join an Event
                <img
                  className={clsx(classes.flex, classes.arrow)}
                  src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-home-page-2025/right-arrow.png"
                  alt="right-arrow"
                />
              </a>
            </div>
          </div>
          <div className={classes.w100}>
            <img
              className={clsx(classes.meetupImg, classes.w100, classes.mt24)}
              src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-home-page-2025/user-group.png"
              alt="user group"
            />
          </div>
        </div>
        {/* coaching */}
        <div className={classes.mlr60}>
          <div>
            <span className={classes.playText}>Doorstep Coaching</span>
            <h2 className={classes.tapHead}>Coaching That Comes Home</h2>
            <p className={classes.tapPara}>
              No traffic, no stress. Get top-notch coaching right inside your
              apartment complex for kids, adults, and anyone looking to level up
              their game, literally from home.
            </p>
            <div className={classes.heroContainer}>
              <img
                className={clsx(classes.heroImg, classes.w100)}
                src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-home-page-2025/mob-infra.png"
                alt="coaching infra"
              />
            </div>
          </div>
          <div className={classes.inlineBlock}>
            <a
              className={classes.cta}
              href="https://www.khelomore.com/sports-coaching"
              target="_blank"
            >
              Get Coaching at Home
              <img
                className={clsx(classes.flex, classes.arrow)}
                src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-home-page-2025/right-arrow.png"
                alt="right-arrow"
              />
            </a>
          </div>
        </div>
        {/* card for blog and event */}
        <div
          className={clsx(
            classes.flex,
            classes.spaceBw,
            classes.alignCenter,
            classes.flexCol,
          )}
        >
          <div className={classes.pdr24}>
            <div className={clsx(classes.blogCard, classes.w100)}>
              <span className={clsx(classes.blogText, classes.tapPara)}>
                Blogs
              </span>
              <h2 className={classes.playBook}>The Playbook</h2>
              <p className={clsx(classes.blogText, classes.tapPara)}>
                From grassroots journeys to game-changing trends - dive into the
                world of sports, community, and culture. Whether you’re a
                weekend warrior or a curious fan, we’ve got something for you.
              </p>
              <div className={classes.inlineBlock}>
                <a
                  className={clsx(classes.blogCta, classes.cta)}
                  href="https://blog.khelomore.com/"
                  target="_blank"
                >
                  Read the Blog
                  <img
                    className={clsx(classes.flex, classes.arrow)}
                    src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-home-page-2025/black-arrow.png"
                    alt="arrow"
                  />
                </a>
              </div>
            </div>
          </div>

          <div className={classes.pdl24}>
            <div className={clsx(classes.eventCard, classes.w100)}>
              <span className={clsx(classes.blogText, classes.tapPara)}>
                Corporate Events
              </span>
              <h2 className={classes.playBook}>Game Day, The Office Way</h2>
              <p className={clsx(classes.blogText, classes.tapPara)}>
                Skip the boring offsite. Host a sports day your team will
                actually enjoy - with expert coaches, curated experiences, and
                just the right amount of friendly fire.
              </p>
              <div className={classes.inlineBlock}>
                <a
                  className={clsx(classes.blogCta, classes.cta)}
                  href="https://docs.google.com/forms/d/e/1FAIpQLSfFTFxlpwh82jPgVkKMua7XP0ijLKcc2rEEw7wk5YV48zen-Q/viewform?usp=header"
                  target="_blank"
                >
                  Plan a Corporate Event
                  <img
                    className={clsx(classes.flex, classes.arrow)}
                    src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-home-page-2025/black-arrow.png"
                    alt="arrow"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* social media */}
        {/* <div>
          <center className={classes.mtb32}>
            {socialMedia?.map((item, idx) => (
              <a target="_blank" href={item?.url} key={item?.alt}>
                <img
                  className={classes.socialIcon}
                  src={item?.src}
                  alt={item?.alt}
                />
              </a>
            ))}
          </center>
        </div> */}
        {/* =========================================
            FAQ SECTION
        ========================================= */}

        <section
          ref={faqSectionRef}
          className={classes.faqSection}
          aria-labelledby="faq-title"
        >
          <div className={classes.faqContainer}>
            {/* FAQ HEADER */}

            <div className={classes.faqHeader}>
              <h2 id="faq-title" className={classes.faqTitle}>
                FAQs
              </h2>

              <button
                type="button"
                className={classes.faqToggleTop}
                onClick={handleFaqToggle}
                aria-expanded={showAllFaqs}
                aria-controls="faq-list"
              >
                {showAllFaqs ? "SEE LESS" : "SEE ALL"}
              </button>
            </div>

            {/* FAQ LIST */}

            <div id="faq-list" className={classes.faqList}>
              {faqData.map((faq, index) => (
                <article
                  key={faq.question}
                  className={clsx(
                    classes.faqItem,
                    index >= 3 && !showAllFaqs && classes.faqItemHidden,
                  )}
                >
                  <h3 className={classes.faqQuestion}>{faq.question}</h3>

                  <p className={classes.faqAnswer}>{faq.answer}</p>
                </article>
              ))}
            </div>

            {/* BOTTOM SEE LESS */}

            {showAllFaqs && (
              <div className={classes.faqBottomAction}>
                <button
                  type="button"
                  className={classes.faqToggleBottom}
                  onClick={handleFaqToggle}
                  aria-label="Show fewer frequently asked questions"
                >
                  SEE LESS
                </button>
              </div>
            )}
          </div>
        </section>
      </main>
    </>
  );
}
